module.exports = __webpack_public_path__ + "img/ico-export.b036493d.svg";